module.exports = __webpack_public_path__ + "static/img/3.01195a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/3.png
// module id = Jsx8
// module chunks = 0